import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const beneficios = [
  {
    img: "/building-websites.svg",
    title: "Páginas web a medida",
    desc: "Creamos sitios únicos que reflejan la identidad y objetivos de tu marca.",
  },
  {
    img: "/create.svg",
    title: "Software a medida",
    desc: "Automatizamos tus procesos para reducir costos y aumentar la eficiencia.",
  },
  {
    img: "/online-shopping.svg",
    title: "Tiendas Online",
    desc: "Diseñamos e integramos tu ecommerce con pagos seguros y experiencia de usuario optimizada.",
  },
];

function BenefitsSection({ id }) {
  return (
    <section id={id} className="py-20 px-6 bg-background">
      <motion.h2
        className="text-4xl md:text-5xl font-bold text-secondary font-anton uppercase text-center"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Llévalo al siguiente nivel
      </motion.h2>

      <motion.p
        className="mt-4 text-gray-300 text-lg max-w-2xl mx-auto text-center"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        viewport={{ once: true }}
      >
        Impulsa tu negocio con soluciones digitales
      </motion.p>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {beneficios.map((b, idx) => (
          <motion.div
            key={idx}
            className={`flex flex-col items-center bg-gradient-to-r from-blue-600 via-teal-600 to-blue-700 rounded-2xl shadow-lg p-8 transition-all duration-300`}
            whileHover={{
              scale: 1.05,
              translateY: "-10px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              backgroundColor: "rgba(0, 0, 0, 0.1)", // Hacer el fondo más oscuro al pasar el ratón
            }}
            initial={{ opacity: 1 }}
            transition={{ duration: 0.1 }}
          >
            <motion.div
              className="relative mb-6 w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-lg"
            >
              <motion.img
                src={b.img}
                alt={b.title}
                className="w-full h-full object-contain"
              />
            </motion.div>
            <motion.h3
              className="text-2xl font-semibold text-white mb-4"
            >
              {b.title}
            </motion.h3>
            <motion.p className="text-sm text-white/80 leading-relaxed text-center">
              {b.desc}
            </motion.p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default BenefitsSection;
